module.exports = __webpack_public_path__ + "img/V-R-6-load-standup-shadow.25fad445.png";